import colors from '../../../../../public/colors'


/* eslint-disable */

const styles = theme => {
    const { mode } = theme.palette
    return {
            actionRow: {
        '& > button': {
            marginLeft: 'auto'
        },
        justifyContent: 'flex-end',
        height: '100%',
        padding: '16px 24px'
    },
    button: {
        '&.MuiButton-root': {
            border: '1px solid #006AC3',
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            height: '40px',
            marginLeft: '10px',
            width: '104px'
        },
        '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)'
        }
    },
    buttonContainer: {
        '@media screen and (max-width: 320px)': {
            paddingBottom: '20px',
            paddingTop: '24px'
        },
        backgroundColor: colors[mode].primaryBackground,
    },
    buttonSkip: {
        '&.MuiButton-root': {
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: '#003168',
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.46px',
            lineHeight: '16px',
            marginLeft: '10px',
            padding: '8px 16px',
            textTransform: 'uppercase',
            width: 'auto',
        },
        '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)'
        }
    },
    buttonSubmit: {
        '&.MuiButton-root': {
            backgroundColor: '#FEDF01',
            border: '1px solid #FEDF01',
            borderRadius: '2px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: '#003168',
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '12px',
            fontWeight: 400,
            height: '32px',
            letterSpacing: '0.46px',
            lineHeight: '16px',
            marginLeft: '10px',
            padding: '8px 16px',
            textTransform: 'uppercase',
            width: 'auto'
        },
        '&:disabled': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
            opacity: '0.5'
        }
    },
    countdownProgress: {
        color: colors[mode].mobileIcon
    },
    content: {
        fontSize: '24px',
        fontWeight: '500'
    },
    contentContainer: {
        borderRadius: '3px',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    contentDivider: {
        paddingTop: '25px'
    },
    contentSection: {
        fontSize: '20px'
    },
    countdown: {
        position: 'relative',
    },
    countdownTypography: {
        left: '50%',
        position: 'absolute',
        top: '45%',
        transform: 'translate(-50%, -50%)',
    },
    divider: {
        background: '#FFC72A',
        padding: '2px',
        width: '50px'
    },
    errorContainer: {
        '@media screen and (max-width: 1350px)': {
            padding: '0px 20px'
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    fieldsContainer: {
        backgroundColor: colors[mode].primaryBackground,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: '235px',
        width: '100%'
    },
    formContainer: {
        backgroundColor: colors[mode].primaryBackground,
        flexDirection: 'column',
    },
    show: {
        display: 'block'
    },
    hide: {
        display: 'none'
    },
    link: {
        alignSelf: 'start',
        color: '#1E99FA',
        display: 'flex',
        justifyContent: 'center',
        marginRight: '8px',
        marginTop: '8px',
        textDecoration: 'underline',
        textDecorationColor: '#1E99FA'
    },
    disabledLink: {
        alignSelf: 'start',
        cursor: 'default',
        display: 'flex',
        PointerEvents: 'none',
        color: colors[mode].secondaryText,
        marginRight: '8px',
        marginTop: '8px',
    },
    loader: {
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '0',
        width: '100%',
        'z-index': '10'
    },
    messageContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '8px',
    },
    root: {
        padding: theme.spacing(0, 2, 2, 2)
    },
    verificationContainer: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginLeft: '0px',
        marginTop: '0px',
        paddingTop: theme.spacing(4),
        width: '100%'
    },
    successMsg: {
        color: theme.palette.success.main,
        display: 'flex',
        fontSize: '14px',
        justifyContent: 'center',
    },
    otpInput: {
        color: colors[mode].primaryText,
        width: '30px',
        height: '40px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: '400',
        border: 'none',
        borderBottom: `2px solid ${colors[mode].secondaryText}`,
        borderRadius: '0',
        outline: 'none',
        background: 'transparent',
        letterSpacing: '0.15px',
        lineHeight: '20px',
        transition: 'border-color 0.2s',
        '&:focus': {
            borderBottomColor: '#006AC3',
            borderBottomWidth: '2px'
        },
        '&:hover': {
            borderBottomColor: '#006AC3)'
        }
    },
    otpInputError: {
        '&&': {
            borderBottomColor: '#d32f2f',
            borderBottomWidth: '2px'
        }
    },
    otpInputFilled: {
        borderBottomColor: '#006AC3',
        borderBottomWidth: '2px'
    },
    otpInputVerified: {
        '&&': {
            borderBottomColor: colors[mode].successTextLight,
            color: colors[mode].successTextLight,
            borderBottomWidth: '2px'
        }
    },
    otpLabel: {
        color: colors[mode].secondaryText,
        fontSize: '12px',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '12px',
        letterSpacing: '0.15px',
        marginBottom: '8px',
    },
    otpLabelCall: {
        color: colors[mode].secondaryText,
        fontSize: '12px',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '12px',
        letterSpacing: '0.15px',
        marginBottom: '8px',
    },
    errorText: {
        '@media screen and (max-width: 1350px)': {
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            overflowWrap: 'break-word'
        },
        display: 'block',
        marginBottom: '8px',
        marginLeft: '5px',
        marginTop: '8px',
        textAlign: 'center'
    },
    successContainer: {
        '@media screen and (max-width: 1350px)': {
            padding: '0px 20px'
        },
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    verificationCodeContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginLeft: '0px',
        marginTop: '19px',
        width: '100%'
    },
    verificationCodeBox: {
        alignItems: 'flex-start',
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    verificationCodeBoxCall: {
        alignItems: 'flex-start',
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    warningLine: {
        background: colors[mode].primaryBackground,
        color: colors[mode].secondaryText,
        fontFamily: 'Roboto',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontSize: '14px',
        fontStyle: 'italic',
        fontWeight: 400,
        letterSpacing: '0.17px',
        lineHeight: '20px',
        padding: '16px 24px 32px 24px'
    },
    warningLineVerified: {
        background: colors[mode].primaryBackground,
        color: colors[mode].secondaryText,
        fontFamily: 'Roboto',
        fontFeatureSettings: '"liga" off, "clig" off',
        fontSize: '14px',
        fontStyle: 'italic',
        fontWeight: 400,
        letterSpacing: '0.17px',
        lineHeight: '20px',
        padding: '16px 24px 32px 24px',
    }
    }
}
export default styles
